import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { CompanyData } from "../../pages";
import { useState } from "react";
import { TableCompanies } from "../hbr_companies";

export interface SelectCompanyProps {
  initialCompany?: CompanyData;
  variant?: "text" | "contained" | "outlined";
  onSelect?: (company?: CompanyData) => void;
  children?: React.ReactNode;
}

export const SelectCompany: React.FC<SelectCompanyProps> = ({ initialCompany, variant, onSelect, children }) => {
  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState<CompanyData | undefined>(initialCompany);


  return <>
    <Button variant={variant} fullWidth onClick={() => setOpen(true)}>
      {children ?? company?.nome ?? "Selecione um Empreendimento"}
    </Button>

    <Dialog
      fullWidth
      open={open}
      maxWidth={false}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Box sx={{ height: "70vh" }}>
          <TableCompanies filter onSearch={(company) => {
            setOpen(false);
            setCompany(company);
            if (onSelect) onSelect(company);
          }} />
        </Box>
      </DialogContent>


      <DialogActions>
        <Button variant="contained" onClick={() => setOpen(false)}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog >
  </>;
};